// Thumbnail helper for design photos.
//
// Our own S3/CloudFront photos (inbound copies them there since Nov 2026)
// are stored as `<name>.<hash>.webp` with an 800px copy next to them as
// `<name>.<hash>.w800.webp` (backend services/s3_media.py). For any width up
// to 800 we serve that smaller copy.
//
// Older Cloudinary photos are resized on the fly (f_auto,q_auto,w_N).
// Any other URL (or empty) is returned unchanged.
//
// Pick a width close to the largest the image is displayed at. Examples:
//   cldThumb(url, 96)   small badge / avatar
//   cldThumb(url, 300)  grid tile / card
//   cldThumb(url, 600)  detail modal / large preview
const S3_SERVED_WEBP = /^https:\/\/[^/]+\.cloudfront\.net\/.+\.[0-9a-f]{10}\.webp$/;

export function cldThumb(url, w = 300) {
  if (!url || typeof url !== 'string') return url || '';
  if (S3_SERVED_WEBP.test(url)) return w <= 800 ? url.replace(/webp$/, 'w800.webp') : url;
  if (!url.includes('res.cloudinary.com') || !url.includes('/upload/')) return url;
  return url.replace('/upload/', `/upload/f_auto,q_auto,w_${w}/`);
}
